var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEventTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.62 10.04C22.84 9.99 23 9.78 23 9.55V6C23 5.45 22.55 5 22 5H16V6V8C16 8.28 15.78 8.5 15.5 8.5C15.22 8.5 15 8.28 15 8V6V5H2C1.45 5 1 5.45 1 6V9.55C1 9.78 1.16 9.99 1.38 10.03C2.3 10.21 3 11.03 3 12C3 12.98 2.3 13.79 1.38 13.96C1.15 14.01 1 14.21 1 14.44V18C1 18.55 1.45 19 2 19H15V18V16C15 15.72 15.5 15.5 15.5 15.5C15.78 15.5 16 15.72 16 16V18V19H22C22.55 19 23 18.55 23 18V14.44C23 14.21 22.85 14.01 22.62 13.96C21.7 13.79 21 12.98 21 12C21 11.03 21.7 10.22 22.62 10.04ZM16 13.5C16 13.78 15.78 14 15.5 14C15.5 14 15 13.78 15 13.5V10.5C15 10.22 15.5 10 15.5 10C15.78 10 16 10.22 16 10.5V13.5Z",
    fill: "#6E6E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventTicket);
export default __webpack_public_path__ + "static/media/event-ticket.a761207a49a435cfd2fa1664f612e911.svg";
export { ForwardRef as ReactComponent };